import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { isEmpty } from '../../../shared/services/lodashInJS.js';

import actions from '../../components/CurrentUserLoader/actions.js';
import submit from './submit.js';
import mustBeLogged from '../../components/Must/MustBeLogged.jsx';
import conf from '../../../shared/conf.js';
import mustHaveAcceptedCGU from '../../components/Must/MustHaveAcceptedCGU.jsx';

class AccountContainer extends Component {
  updateUser = (user) => {
    this.props.setCurrentUser(user);
  };

  /**
   * @warning attention ne retourne rien, si pas de call a faire.
   */
  submitUser = async (values) => {
    if (isEmpty(values)) {
      return;
    }

    return await submit({
      user: this.props.currentUser.id,
      ...values
    });
  };

  render() {
    const {view: Component, ...props} = this.props;

    return (
      <Component
        {...props}
        updateUser={this.updateUser}
        updateFreelance={this.updateFreelance}
        submitFreelance={this.submitFreelance}
        submitUser={this.submitUser}>
        {this.props.children}
      </Component>
    );
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(
  mustHaveAcceptedCGU(AccountContainer),
  conf.accountTypes.do
));